import GameList from './game.list';
import GameEdit from './game.edit';
import GameShow from './game.show';

export default {
  list: GameList,
  edit: GameEdit,
  show: GameShow,
};
